import { SavedFilterItem } from '@/lib/saved-filters';
import { MenuCloseContext } from '@/contexts/menu/helpers';
import { FC, useContext } from 'react';
import { MenuItem as MuiMenuItem, Stack } from '@mui/material';
import Text from '@/components/text';

interface Props {
  savedFilter: SavedFilterItem;
  onApply: (filterId: string) => void;
}

const ViewMenuItem: FC<Props> = ({ savedFilter, onApply }) => {
  const closeMenu = useContext(MenuCloseContext);
  const { id, name } = savedFilter;

  const handleApply = () => {
    onApply(id);
    closeMenu?.();
  };

  return (
    <MuiMenuItem onClick={handleApply}>
      <Stack direction="row" width="100%" justifyContent="space-between" alignItems="center">
        <Text size="small">{name}</Text>
      </Stack>
    </MuiMenuItem>
  );
};

export default ViewMenuItem;
